import amazonUsConfig from './amazon_us.json' with { type: 'json' };
import amazonCaConfig from './amazon_ca.json' with { type: 'json' };
import amazonMockConfig from './amazon_mock.json' with { type: 'json' };
import safewayConfig from './safeway.json' with { type: 'json' };
import walmartConfig from './walmart.json' with { type: 'json' };
import doordashConfig from './doordash.json' with { type: 'json' };
import targetConfig from './target.json' with { type: 'json' };
import bestbuyConfig from './bestbuy.json' with { type: 'json' };
import gmailConfig from './gmail.json' with { type: 'json' };
import type { StoreConfig, RetailerIdentity } from '../modules/Config';

export const ALL_STORES: StoreConfig[] = [
  amazonUsConfig as StoreConfig,
  amazonCaConfig as StoreConfig,
  amazonMockConfig as StoreConfig,
  safewayConfig as StoreConfig,
  walmartConfig as StoreConfig,
  doordashConfig as StoreConfig,
  targetConfig as StoreConfig,
  bestbuyConfig as StoreConfig,
  gmailConfig as StoreConfig,
];

// One RetailerIdentity per retailer_id — first occurrence wins.
export const RETAILER_CONFIGS = ALL_STORES.reduce<
  Record<string, RetailerIdentity>
>((acc, store) => {
  if (!acc[store.retailer_id]) {
    const {
      retailer_id,
      retailer_name,
      logo_url,
      requires_password,
      login_input_type,
      login_placeholder,
    } = store;
    acc[store.retailer_id] = {
      retailer_id,
      retailer_name,
      logo_url,
      requires_password,
      login_input_type,
      login_placeholder,
    };
  }
  return acc;
}, {});

export function getStoreConfig(retailerKey: string): StoreConfig | undefined {
  return ALL_STORES.find((store) => store.retailer_key === retailerKey);
}
